import React from 'react';
import { Helmet } from 'react-helmet';
import styled from '@emotion/styled';
import { scMixinFixedFull } from '@utils/emotion/mixins';

const NotSupport: React.FC = () => {
  document.documentElement.classList.add('is-mobile');

  return (
    <NotSupportContainer>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no" />
      </Helmet>
      <div className="content">
        <div className="illustration">
          <img src="/assets/svg/common/people-desktop.svg" alt="Illustration" />
        </div>
        <p className="message">
          PC로 사용하면 더욱 최적화된 sparky.studio를 만날 수 있습니다. 지금 바로 접속하여
          만나보세요!
        </p>
      </div>
    </NotSupportContainer>
  );
};

const NotSupportContainer = styled.div`
  ${scMixinFixedFull};
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
  }

  .illustration {
    width: 20vh;
    margin: 0 auto;

    img {
      display: block;
      width: 100%;
    }
  }

  .message {
    margin: 2em 0 0;
    padding: 0 2em;
    color: #334d6e;
    word-break: keep-all;
    text-align: center;
  }
`;

export default NotSupport;
